// import * as types from './mutations-types'
import pointsMailApi from '../../../../../api/wx-member/points-mall/points-mall'
import {DOWNLOAD_FILE} from '../../../../../common/utils/uploadFileUtil'

export default {
  getMyExtendedInsurance: ({commit}, data) => {
    return new Promise(resolve => {
      pointsMailApi.getMyExtendedInsurance(data)
        .then(result => {
          let list = result.data.filter(item => {
            let imgList = []
            if (item.codeToFileIds && item.codeToFileIds.programmeAttechment) {
              item.codeToFileIds.programmeAttechment.filter((itemTwo, indexTwo) => {
                let img = `${DOWNLOAD_FILE}${itemTwo}?X-Authorization=${localStorage.getItem('token')}`
                imgList.push(img)
              })
            }
            item.codeToFileIds.programmeAttechment = imgList
            return item
          })
          result.data = list
          resolve(result)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-extended-insurance/store/actions.js